import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Input, Label, FormGroup, Modal, ModalHeader, ModalBody } from "reactstrap";
import { BASE_URL } from "../../../../constants";
import DepositReportTable from "./table";
import { FaCalendar, FaTimes } from "react-icons/fa";

function DepositReportView() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [errMsg, setErrMsg] = useState(null);
	const [successMsg, setSuccessMsg] = useState(null);
	const [propertyName, setPropertyName] = useState([]);
	const [selectedProperty, setSelectedProperty] = useState(null);
	const [basedOnType, setBasedOnType] = useState('INSPECTION');
	const [basedOnId, setBasedOnId] = useState(null); 
	const [basedOnOptions, setBasedOnOptions] = useState([]); 
	const [selectedInspections, setSelectedInspections] = useState([null, null]);
	const [securityDeposit, setSecurityDeposit] = useState('');
	const [petDeposit, setPetDeposit] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [propertyAreas, setPropertyAreas] = useState([]);
	const [reportItems, setReportItems] = useState([]);
	const [isEdit, setIsEdit] = useState(false);
	const [viewItemImage, setViewItemImage] = useState(null);
	const [isExporting, setIsExporting] = useState(false);

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/reports/deposit/specific-report/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setPropertyName(data.result.property_name);
						setSelectedProperty(data.result.property_id);
						setSecurityDeposit(data.result.security_deposit);
						setPetDeposit(data.result.pet_deposit);
						setReportItems(data.result.items || []);
						setBasedOnType(data.result.based_on_type || 'INSPECTION');
						setBasedOnId(data.result.based_on_id || null);
					}
					else {
						console.error("Error: Unable to fetch report data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);

	useEffect(() => {

		setPropertyAreas([]);

		if (selectedProperty) {
			const token = localStorage.getItem('token');
			if (token) {
				setIsLoading(true);
				fetch(`${BASE_URL}/reports/deposit/property-areas/${selectedProperty}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
					.then(response => response.json())
					.then(data => {
						setIsLoading(false);
						if (data.status) {
							setPropertyAreas([...data.result]);
						}
						else {
							console.error("Error: Unable to fetch property data.");
						}
					})
					.catch(error => console.error("Error fetching data:", error));
			}
		}

	}, [selectedProperty])

	useEffect(() => {
		if (!selectedProperty) {
			return;
		}
		
		const token = localStorage.getItem('token');

		if (basedOnType == 'INSPECTION') {
			fetch(`${BASE_URL}/dropdown/inspections?property_id=${selectedProperty}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setBasedOnOptions(data.result.map((inspection) => ({
							label: `${formatInspectionActivity(inspection.activity)} - ${new Date(inspection.inspection_date).toLocaleDateString('en-US')}`,
							id: inspection.id,
							data: {...inspection}
						})));
					}
					else {
						console.error("Error: Unable to fetch inspection data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {

			fetch(`${BASE_URL}/dropdown/comparison-reports?property_id=${selectedProperty}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setBasedOnOptions(data.result.map((report) => ({
							label: `${formatInspectionActivity(report.inspection_1_activity)} - ${formatInspectionActivity(report.inspection_2_activity)} - ${new Date(report.created_at).toLocaleDateString('en-US')}`,
							id: report.id,
							data: {...report}
						})));
					}
					else {
						console.error("Error: Unable to fetch inspection data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		}
	}, [basedOnType, selectedProperty])

	useEffect(() => {
		if (!basedOnId || !selectedProperty || basedOnOptions.length == 0) {
			return;
		}

		if (basedOnType == 'INSPECTION') {
			getInspectionDetails(basedOnId, 0);
		} else {
			const report = basedOnOptions.find(option => option.id == basedOnId);
			if (report) {
				const inspection1 = report.data.inspection_1;
				const inspection2 = report.data.inspection_2;
				console.log('report', inspection1, inspection2);
				getInspectionDetails(inspection1, 0);
				getInspectionDetails(inspection2, 1);
			}
		}
	}, [basedOnId, basedOnOptions, basedOnOptions])

	const getInspectionDetails = (ispId, index) => {
		if (ispId == null || ispId == "") {
			// setErrMsg("Please select inspection");
			return;
		}

		setSelectedInspections(prev => {
			const prevReports = [...prev];
			prevReports[index] = null;
			return prevReports;
		})
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/inspection/${ispId}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						const formattedInspection = { ...data.result };
						formattedInspection.created_at = new Date(data.result.created_at).toLocaleDateString('en-US');
						
						setSelectedInspections(prev => {
							const prevReports = [...prev];
							prevReports[index] = formattedInspection;
							return prevReports;
						})
					} else {
						console.error("Error: Unable to fetch inspections data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		}
	}

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const handleSubmit = () => {
		if (!selectedProperty) {
			setErrMsg("Please select a property.");
			return;
		}
		if (securityDeposit < 0) {
			setErrMsg("Security deposit cannot be negative.");
			return;
		}
		if (petDeposit < 0) {
			setErrMsg("Pet deposit cannot be negative.");
			return;
		}
		setErrMsg(null);
		setSuccessMsg(null);
		const token = localStorage.getItem('token');
		if (!token) {
			setErrMsg("Authorization token is missing.");
			return;
		}
		const data = {
			propertyId: selectedProperty,
			securityDeposit: securityDeposit,
			petDeposit: petDeposit,
			reportItems: reportItems,
			basedOnType: basedOnType,
			basedOnId: basedOnId,
		};

		fetch(`${BASE_URL}/reports/deposit/update/${id}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then(data => {
				if (data.status) {
					setSuccessMsg(data.message || "Deposit report updated successfully.");
					setIsEdit(false);
				} else {
					setErrMsg(data.message || "Failed to create deposit report.");
				}
			})
			.catch(error => {
				console.error("Error creating deposit report:", error);
				setErrMsg("An error occurred while creating the deposit report.");
			});
	}

	const handleGenerateReport = async () => {
		if (!id) return;

		const token = localStorage.getItem('token');

		if (!token) {
			console.error('Error: Authorization token is missing.');
			return;
		}

		try {
			setIsExporting(true)
			const response = await fetch(`${BASE_URL}/reports/deposit/export/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			setIsExporting(false)
			const data = await response.json();
			console.log(data, 'response');

			if (data.status) {
				const newTab = window.open(data.result, '_blank');

				if (newTab) {
					newTab.document.title = 'Deposit Report';
				} else {
					console.error('Failed to open new tab');
				}
			} else {
				setErrMsg(data.message);
			}

		} catch (error) {
			console.error('Error generating PDF:', error);
			setErrMsg(error.message);
		}
	};

	// console.log('reportItems', reportItems);

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}
			{successMsg !== null && <Alert color="success">{successMsg}</Alert>}

			<Row>
				<Col><h3>Deposit Withholding Report</h3></Col>
				<Col className="text-end">
					{(!isEdit) ? (
						<Button color="dark" onClick={() => setIsEdit(true)}>Edit Report</Button>
					) : null}
					<Button color="primary" className="ms-2" type="button" disabled={isExporting} onClick={handleGenerateReport} style={{width: 200}} >{isExporting ? 'Exporting...' : 'Export Report'}</Button>
				</Col>
			</Row>
			
			
			<Card>
				<CardBody>
					
					<Row className="mb-2">
						<Col md={6}>
							<FormGroup>
								<Label>Property</Label>
								<Input type="text" value={propertyName} disabled />
							</FormGroup>
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>Security Deposit</Label>
								<Input type="number" value={securityDeposit} disabled={!isEdit} onChange={(e) => setSecurityDeposit(e.target.value)} />
							</FormGroup>
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>Pet Deposit</Label>
								<Input type="number" value={petDeposit} disabled={!isEdit} onChange={(e) => setPetDeposit(e.target.value)} />
							</FormGroup>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col md={3}>
							<FormGroup>
								<Label>Report Type</Label>
								<Input type="select" name="report_type" id="report_type" disabled value={basedOnType} >
									<option value="INSPECTION">Inspection</option>
									<option value="COMPARISON">Comparison Report</option>
								</Input>
							</FormGroup>
							
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>{(basedOnType == 'INSPECTION') ? 'Pick an Inspection' : 'Pick an Comparison Report'}</Label>
								<Input type="select" name="based_id" id="based_id" disabled value={basedOnId} >
									<option value="">{(basedOnType == 'INSPECTION') ? 'Select Inspection' : 'Select Comparison Report'}</option>
									{basedOnOptions.map(p => {
										return (
											<option key={p.id} value={p.id}>{p.label}</option>
										)
									})}
								</Input>
							</FormGroup>
						</Col>
					</Row>

					{(selectedProperty && basedOnId) ? (
						<>
						{isLoading ? (
							<p className="text-center">Loading...</p>
						) : (
							<DepositReportTable 
								propertyAreas={propertyAreas}
								reportItems={reportItems}
								setReportItems={setReportItems}
								isEdit={isEdit}
								selectedInspections={selectedInspections}
								basedOnType={basedOnType}
								setViewItemImage={setViewItemImage}
							/>
						)}
						</>
					) : null}

					{(isEdit) && (
					<div className='text-end'>
						<Button color="secondary" type="button" onClick={() => setIsEdit(false)}>Cancel</Button>
						<Button color="primary" type="button" onClick={handleSubmit}>Update Report</Button>
					</div>
					)}
				</CardBody>
			</Card>

			{(viewItemImage !== null) ? (
			<Modal isOpen={viewItemImage !== null} toggle={() => setViewItemImage(null)} centered size="lg">
				<ModalHeader toggle={() => setViewItemImage(null)} style={{ display: 'flex', justifyContent: 'space-between' }} close={
					<button className="close" onClick={() => setViewItemImage(null)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
						<FaTimes size={20} />
					</button>
				}>
					<div>{viewItemImage?.itemName}</div>
				</ModalHeader>
				<ModalBody>
					<img
						src={viewItemImage?.image}
						alt={viewItemImage?.itemName}
						style={{ width: '100%' }}
					/>

					<div style={{ marginTop: '15px' }}></div>

					<p><FaCalendar /> {new Date(viewItemImage?.createdAt).toLocaleDateString('en-US')}</p>
				</ModalBody>
			</Modal>
			) : null}
		</div>
	);
}

export default DepositReportView;
